var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8802 14.4351H11.8814V11.3023C11.8814 10.5553 11.8664 9.59385 10.8389 9.59385C9.79716 9.59385 9.63816 10.4068 9.63816 11.2476V14.4351H7.63866V7.99335H9.55866V8.87085H9.58491C9.85341 8.36535 10.5059 7.8306 11.4809 7.8306C13.5059 7.8306 13.8809 9.1641 13.8809 10.8988V14.4351H13.8802ZM5.38116 7.1121C5.22857 7.11229 5.07745 7.08237 4.93645 7.02405C4.79546 6.96573 4.66736 6.88015 4.5595 6.77222C4.45164 6.6643 4.36615 6.53614 4.30791 6.39511C4.24968 6.25407 4.21986 6.10293 4.22016 5.95035C4.2203 5.72072 4.28854 5.4963 4.41624 5.30546C4.54393 5.11461 4.72535 4.96592 4.93755 4.87819C5.14976 4.79045 5.38321 4.76761 5.60839 4.81255C5.83357 4.8575 6.04037 4.9682 6.20264 5.13068C6.3649 5.29315 6.47534 5.50009 6.51999 5.72533C6.56465 5.95057 6.5415 6.184 6.45349 6.39609C6.36548 6.60817 6.21656 6.7894 6.02555 6.91685C5.83454 7.0443 5.61003 7.11225 5.38041 7.1121H5.38116ZM6.38316 14.4351H4.37841V7.99335H6.38391V14.4351H6.38316ZM14.8814 2.93085H3.37566C2.82366 2.93085 2.37891 3.36585 2.37891 3.9036V15.4581C2.37891 15.9958 2.82441 16.4308 3.37491 16.4308H14.8784C15.4289 16.4308 15.8789 15.9958 15.8789 15.4581V3.9036C15.8789 3.36585 15.4289 2.93085 14.8784 2.93085H14.8807H14.8814Z",
    fill: "#9FDCE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.128906 0.680847)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.55a5ff6fc5d0849835e30b59f2c8a583.svg";
export { ForwardRef as ReactComponent };